// extracted by mini-css-extract-plugin
module.exports = {"children":"ActionsModal_children__hdtA9","actions":"ActionsModal_actions__8FDH4","waveAnimation":"ActionsModal_waveAnimation__Jsdqv","marquee":"ActionsModal_marquee__zJPfS"};